import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TextBox } from '~/components/Chat';
import { GuessingStep, MessageResponse } from '~/types';
import { useCommonChatStore, useUserStore } from '~/store';
import InputHeightContainer from '../InputHeightContainer';
import ChatContent from './ChatContent';

interface GuessingProps {
  webSocket: React.RefObject<WebSocket>;
  messages: MessageResponse[];
  setMessages: React.Dispatch<React.SetStateAction<MessageResponse[]>>;
  waitingChat: boolean;
  handleSetWaitingChatTrue: () => void;
  onNextStep: (step: GuessingStep) => void;
}

export default function Guessing({
  webSocket,
  messages,
  setMessages,
  waitingChat,
  handleSetWaitingChatTrue,
  onNextStep,
}: GuessingProps) {
  const { id: chatroomId } = useParams();

  const email = useUserStore((state) => state.email);
  const room_type = useCommonChatStore((state) => state.roomType);
  const members = useCommonChatStore((state) => state.chatMembers);
  const AIName = members
    .filter((member) => member.id !== email)
    .map((member) => member.name)
    .join(', ');

  const [showTextBox, setShowTextBox] = useState<boolean>(false);

  return (
    <>
      <ChatContent
        name={AIName}
        messages={messages}
        waitingChat={waitingChat}
        onNextStep={onNextStep}
        showTextBox={showTextBox}
        setShowTextBox={setShowTextBox}
      />
      <InputHeightContainer>
        <TextBox
          webSocket={webSocket}
          chatroomId={chatroomId || ''}
          setWaitingChatTrue={handleSetWaitingChatTrue}
          setMessages={setMessages}
          room_type={room_type ? room_type : 'user'}
          showTextBox={showTextBox}
          setShowTextBox={setShowTextBox}
        />
      </InputHeightContainer>
    </>
  );
}
